/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-26 14:36:22
 */
import React from "react";
import lazyLoad from "@/routers/utils/lazyLoad";
import { LayoutIndex } from "@/routers/constant";
import { RouteObject } from "@/routers/interface";
import TeamSetting from "@/pages/Team/index";
// 首页模块
const Team: Array<RouteObject> = [
	{
		element: <LayoutIndex />,
		path: "/team",
		meta: {
			title: "Team",
			hideInMenu: true
		},
		children: [
			{
				path: "/team",
				// element: lazyLoad(React.lazy(() => import("@/pages/Team/index"))),
				element: <TeamSetting />,
				meta: {
					requiresAuth: false,
					title: "Team",
					key: "team"
				}
			}
		]
	}
];

export default Team;
